import React from 'react';
import PropTypes from 'prop-types';

import CurrencyHelper from '../../shared/helpers/CurrencyHelper';

const PricingBox = ({ price }) => {
  const priceListOptions = [];
  let offerIndex = 0;
  if (price.offers !== null && price.offers !== undefined && price.offers.length > 0) {
    for (const offer of price.offers) {
      if (offer.price >= 0) {
        priceListOptions.push(
          <li key={offerIndex}>
            <span className="slotPriceListName">{offer.name}</span>
            <span className="slotPriceListPrice">
              {CurrencyHelper.format('en-GB', offer.priceCurrency, offer.price)}
            </span>
          </li>
        );
        offerIndex += 1;
      }
    }
    if (priceListOptions.length > 0) {
      return (
        <span className="slotPriceList">
          <ul>{priceListOptions}</ul>
        </span>
      );
    }
  }
  return null;
};

PricingBox.propTypes = {
  price: PropTypes.shape({
    offers: PropTypes.arrayOf(PropTypes.object),
  }),
};

/**
 * @param {import('../../shared/helpers/PriceHelper').PriceList} price
 * @param {boolean} showPrices
 * @returns {React.ReactNode}
 */
function renderPricingBox(price, showPrices) {
  if (!showPrices) {
    return null;
  }
  return <PricingBox price={price} />;
}

export { renderPricingBox };
